import styled from "styled-components";

export const PreviewRoot = styled.div`
    position: absolute;
    inset: 0;
    z-index: 0;
    border-radius: inherit;
    overflow: hidden;
    pointer-events: none;
    background: ${({ theme }) => theme.palette.colors.surface};

    img,
    video,
    wistia-player {
        width: 100%;
        height: 100%;
        display: block;
    }

    wistia-player {
        object-fit: cover;
        border-radius: 0 !important;
    }
`;

export const PreviewPoster = styled.div`
    position: absolute;
    inset: 0;
    z-index: 0;
    opacity: ${({ visible }) => visible ? 1 : 0};
    transition: opacity 0.32s cubic-bezier(0.22, 1, 0.36, 1);
`;

export const PreviewMediaLayer = styled.div`
    position: absolute;
    inset: 0;
    z-index: 1;
    opacity: ${({ visible }) => visible ? 1 : 0};
    transition: opacity 0.42s cubic-bezier(0.22, 1, 0.36, 1);
`;

export const PreviewImage = styled.img`
    object-fit: contain;
    transition:
        transform 0.50s cubic-bezier(0.22, 1, 0.36, 1),
        opacity 0.32s cubic-bezier(0.22, 1, 0.36, 1);
`;

export const PreviewVideo = styled.video`
    object-fit: cover;
`;
